
import apix from '@/api.js'

export default {
  stringToNumberArray (image_ids) {
    if(!image_ids) return []
    let imids = image_ids.split(',')
    let ims = []
    imids.forEach(el => {
      ims.push(Number(el))
    })
    return ims;
  },
  mergeContents(likes, folder) {
    let arr = this.stringToNumberArray(folder.image_ids)
    let arrnew = likes.concat(arr)
    return arrnew.filter((item, pos) => arrnew.indexOf(item) === pos);
  },
  getCurrentFolder(state) {
    if(state.profile.folders) {
      for(var folder of state.profile.folders) {
        if(state.profileFolder === folder.name) {
          return folder
        }
      }
    }
    else {
      state.profile.folders = []
    }
    
    let f = { name: state.profileFolder, image_ids: state.likes.join(',') }
    state.profile.folders.push(f)
    return f
  },
  mergeLikes(state) {
    let folder = this.getCurrentFolder(state)
    state.likes = this.mergeContents(state.likes, folder)
    folder.image_ids = state.likes.join(',')
    this.updateFolder(state, folder)
  },
  updateFolder(state, folder) {
    apix.post('collections/likes/set', folder, { headers: {'Authorization': state.token } })
  }
}